import Swiper from 'swiper';
import {add_swiper_class} from '@otpaysdefalaise/js/tools/swiper';
import Modernizr from 'modernizr';

export default class Slider {

	constructor() {
		Slider.hero();
		Slider.related_post();
	}

	/**
	 * Slider banner
	 */
	static hero() {
		let slider = '[data-id="wpiris-hero-slider"]',
			slider_wrapper = '[data-id="wpiris-hero-slider-wrapper"]',
			slider_item = '[data-id="wpiris-hero-slider-item"]';

		if ($(slider).length > 0) {

			add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

			new Swiper($(slider), {
				mousewheel: {
					forceToAxis: true,
				},
				scrollbar: {
					el: '[data-trigger="swiper-scrollbar-hero"]',
					draggable: true,
					hide: false
				},
				autoplay: {},
				speed: 600,
				slidesPerView: 1,
				loop: false,
				lazy: true,
			});
		}
	}

	/**
	 * Slider contenu relatif
	 */
	static related_post() {

		let slider = '[data-id="wpiris-related-post"]',
			slider_wrapper = '[data-id="wpiris-related-post-wrapper"]',
			slider_item = '[data-swiper-item]';

		if ($(slider).length > 0) {

			$(slider).each(function () {

				add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

				let slides_per_view = undefined !== $(this).attr('data-slides-per-view') ? $(this).attr('data-slides-per-view') : 3,
					slides_per_view_large = undefined !== $(this).attr('data-slides-per-view-large') ? $(this).attr('data-slides-per-view-large') : 3,
					slides_per_view_medium = undefined !== $(this).attr('data-slides-per-view-medium') ? $(this).attr('data-slides-per-view-medium') : 2.2,
					slides_per_view_small = undefined !== $(this).attr('data-slides-per-view-small') ? $(this).attr('data-slides-per-view-small') : 1.2;

				new Swiper($(this), {
					slidesPerView: slides_per_view_small,
					spaceBetween: 10,
					speed: 600,
					keyboard: true,
					freeMode: true,
					watchSlidesVisibility: true,
					passiveListeners: false,
					breakpoints: {
						350: {
							slidesPerView: slides_per_view_small,
							spaceBetween: 20,
						},
						650: {
							slidesPerView: slides_per_view_medium,
							spaceBetween: 20,
						},
						1000: {
							slidesPerView: slides_per_view_large,
							spaceBetween: 20,
						},
						1381: {
							slidesPerView: slides_per_view,
							spaceBetween: 40,
						}
					}
				});

			});
		}
	}

	/**
	 * Slider contenu relatif
	 */
	static related_post_home() {

		let slider = '[data-id="wpiris-related-post"]',
			slider_wrapper = '[data-id="wpiris-related-post-wrapper"]',
			slider_item = '[data-swiper-item]';

		if ($(slider).length > 0) {

			$(slider).each(function () {

				add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

				let slides_per_view = undefined !== $(this).attr('data-slides-per-view') ? $(this).attr('data-slides-per-view') : 3,
					slides_per_view_large = undefined !== $(this).attr('data-slides-per-view-large') ? $(this).attr('data-slides-per-view-large') : 3,
					slides_per_view_medium = undefined !== $(this).attr('data-slides-per-view-medium') ? $(this).attr('data-slides-per-view-medium') : 2.2,
					slides_per_view_small = undefined !== $(this).attr('data-slides-per-view-small') ? $(this).attr('data-slides-per-view-small') : 1.2;

				new Swiper($(this), {
					slidesPerView: slides_per_view_small,
					spaceBetween: 10,
					speed: 600,
					keyboard: true,
					watchSlidesVisibility: true,
					passiveListeners: false,
					scrollbar: {
						el: '[data-trigger="swiper-scrollbar-related-post"]',
						draggable: true,
						hide: false
					},
					breakpoints: {
						350: {
							slidesPerView: slides_per_view_small,
							spaceBetween: 20,
						},
						650: {
							slidesPerView: slides_per_view_medium,
							spaceBetween: 20,
						},
						1000: {
							slidesPerView: slides_per_view_large,
							spaceBetween: 20,
						},
						1381: {
							slidesPerView: slides_per_view,
							spaceBetween: 40,
						}
					}
				});

			});
		}
	}

	/**
	 * Slider strate Falaise home
	 */
	static home_falaise() {
		let slider = '[data-id="wpiris-strate-falaise-slider"]',
			slider_wrapper = '[data-id="wpiris-strate-falaise-slider-wrapper"]',
			slider_item = '[data-id="wpiris-strate-falaise-slider-item"]';

		if ($(slider).length > 0) {

			add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

			new Swiper($(slider), {
				mousewheel: {
					forceToAxis: true,
				},
				autoplay: {
					delay: 5000,
				},
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				speed: 600,
				slidesPerView: 1,
				loop: false,
				lazy: true,
				scrollbar: {
					el: '[data-trigger="swiper-scrollbar-falaise"]',
					draggable: true,
					hide: false
				},
			});
		}
	}

	/**
	 * Slider home thumbs
	 */
	static home_thumbs() {
		let slider = '[data-id="wpiris-thumbs-slider"]',
			slider_wrapper = '[data-id="wpiris-thumbs-slider-wrapper"]',
			slider_item = '[data-swiper-item]';

		if ($(slider).length > 0) {

			add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

			let config = {
				slidesPerView: 1,
				width: 210,
				loop: false,
				allowTouchMove: false,
				spaceBetween: 20,
				speed: 600,
				lazy: true,
				on: {
					reachEnd: function () {
						this.snapGrid = [...this.slidesGrid];
					},
				},
			}

			if (Modernizr.touchevents) {
				config.allowTouchMove = true;
			}

			new Swiper($(slider), config);
		}
	}

	/**
	 * Slider home events
	 */
	static home_events() {
		let slider = '[data-id="wpiris-events-slider"]',
			slider_wrapper = '[data-id="wpiris-events-slider-wrapper"]',
			slider_item = '[data-swiper-item]';

		if ($(slider).length > 0) {

			add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

			let config = {
				slidesPerView: 1,
				autoplay: {
					delay: 3000
				},
				speed: 600,
				lazy: true,
				scrollbar: {
					el: '[data-trigger="swiper-scrollbar-events"]',
					draggable: true,
					hide: false
				}
			}

			new Swiper($(slider), config);
		}
	}

	/**
	 * Slider home temps forts content
	 */
	static home_temps_forts() {
		const slider = '[data-id="wpiris-temps-forts"]',
			slider_wrapper = '[data-id="wpiris-temps-forts-wrapper"]',
			slider_item = '[data-temps-forts-slide]';

		if ($(slider).length) {

			add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

			const config = {
				slidesPerView: 1,
				spaceBetween: 20,
				lazy: true,
				grabCursor: true,
				scrollbar: {
					el: '[data-trigger="swiper-scrollbar-temps-forts"]',
					draggable: true,
					hide: false
				},
				on: {
					transitionEnd: () => {
						const activePost = $(slider_item + '.swiper-slide-active').data('temps-forts-item');
						$('.strateTempsFortsItemsImagesItem').removeClass('is-active');
						$('[data-temps-forts-id="' + activePost + '"]').addClass('is-active');
					}
				},
				breakpoints: {
					650: {
						spaceBetween: 40,
					}
				}
			};

			if (Modernizr.touchevents) {
				config.allowTouchMove = true;
			}

			new Swiper($(slider), config);
		}
	}

	/**
	 * Slider home events
	 */
	static home_inspirations() {
		let slider = '[data-id="wpiris-inspirations-slider"]',
			slider_wrapper = '[data-id="wpiris-inspirations-slider-wrapper"]',
			slider_item = '[data-inspiration-slide]',
			button = '[data-inspiration-link]';

		if ($(slider).length > 0) {

			add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

			let config = {
				slidesPerView: 1,
				autoplay: {
					delay: 3000
				},
				speed: 600,
				lazy: true,
				scrollbar: {
					el: '[data-trigger="swiper-scrollbar-inspirations"]',
					draggable: true,
					hide: false
				},
				on: {
					transitionEnd: () => {
						const activePost = $(slider_item + '.swiper-slide-active').data('inspiration-item');
						const permalink = $(slider_item + '.swiper-slide-active').data('inspiration-permalink');
						$('.strateInspirationsContent').removeClass('is-active');
						$('[data-inspirations-id="' + activePost + '"]').addClass('is-active');
						$(button).attr('href', permalink);
					}
				}
			}

			if (Modernizr.touchevents) {
				config.allowTouchMove = true;
			}

			new Swiper($(slider), config);
		}
	}
}